export const ActionTypes = {
  SUCCESS_API_GET_OPERATORS: 'favorites/SUCCESS_API_GET_OPERATORS',
  FILTER_OPERATOR_NAME: 'favorites/FILTER_OPERATOR_NAME',
  INPUT_FAVORITE_NAME: 'favorites/INPUT_FAVORITE_NAME',
  CHECK_ALL_OPERATORS: 'favorites/CHECK_ALL_OPERATORS',
  RESET_CHECK_OPERATORS: 'favorites/RESET_CHECK_OPERATORS',
  CHECK_OPERATOR: 'favorites/CHECK_OPERATOR',
};

export default ActionTypes;
